import { Money } from '@rygen/rygen-ui/model';

import { ShipmentFinancialStatus } from './ShipmentFinancialStatus';

export class ShipmentFinancialSummary {
  financialStatus?: ShipmentFinancialStatus;
  costEstimate?: Money;

  constructor(opts?: Partial<ShipmentFinancialSummary>) {
    if (opts?.financialStatus != null) {
      if (typeof opts?.financialStatus === 'string') {
        this.financialStatus = ShipmentFinancialStatus[opts.financialStatus];
      } else {
        this.financialStatus = opts.financialStatus;
      }
    }
    if (opts?.costEstimate != null) {
      this.costEstimate = opts.costEstimate;
    }
  }
}
